import { render } from "./PaymentFailure.vue?vue&type=template&id=20cbbada&scoped=true"
import script from "./PaymentFailure.vue?vue&type=script&lang=js"
export * from "./PaymentFailure.vue?vue&type=script&lang=js"

import "./PaymentFailure.vue?vue&type=style&index=0&id=20cbbada&lang=scss&scoped=true"

import exportComponent from "D:\\Epaylater Projects\\microapp-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20cbbada"]])

export default __exports__